export const isSafari = () => {
  return window.navigator.userAgent.includes('Safari');
};
